import type { GetUserDetailsQuery } from "@/gql/graphql";
import { createContext, useContext } from "react";
export interface UserContextType {
  currentUser?: GetUserDetailsQuery["personal_user"]; // 当前用户信息
  isAdmin: boolean; // 是否为管理员
}

export const UserContext = createContext<UserContextType | null>(null);

export const useCurrentUser = () => {
  const context = useContext(UserContext);
  if (!context)
    throw new Error("useCurrentUser must be used within ProtectedUser");
  return context;
};
